import DeleteAnnouncementModal from "./DeleteAnnouncementModal";

export { DeleteAnnouncementModal };
